/**
 * Permissions santé strictes + audit.
 * TEMP-POLICY-SENSEI-NO-HEALTH : l'instructeur ne voit pas les données santé par défaut.
 */
import { TEMP_SENSEI_HEALTH_POLICY } from "./membershipConstants.js";

/**
 * @param {object} viewer { role, username, membershipId, linkedMembershipIds }
 * @param {object} record membership
 * @param {object} [settings]
 */
export function canViewHealthRecord(viewer, record, settings = {}) {
  if (!viewer || !record) return false;
  const role = viewer.role;
  if (role === "hanshi" || role === "admin") return true;
  if (role === "sensei" || role === "assistant") {
    return settings.senseiCanViewHealth === true;
  }
  if (role === "student") {
    return Boolean(
      viewer.membershipId === record.id ||
        (viewer.username && record.identity?.email && viewer.username.toLowerCase() === record.identity.email.toLowerCase()),
    );
  }
  if (role === "parent") {
    const linked = viewer.linkedMembershipIds || [];
    if (linked.includes(record.id)) return true;
    const parentEmail = record.parent?.email;
    return Boolean(viewer.username && parentEmail && viewer.username.toLowerCase() === parentEmail.toLowerCase());
  }
  return false;
}

export function canExportHealthRecord(viewer, record, settings) {
  if (!canViewHealthRecord(viewer, record, settings)) return false;
  return viewer.role === "hanshi" || viewer.role === "admin";
}

export function healthPolicyNote() {
  return TEMP_SENSEI_HEALTH_POLICY;
}

export function makeHealthAuditEntry({ actorUsername, actorRole, membershipId, action }) {
  return {
    id: `health-audit-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    at: new Date().toISOString(),
    actorUsername: actorUsername || "unknown",
    actorRole: actorRole || "guest",
    membershipId,
    action,
  };
}

/** Ne jamais sérialiser la santé dans un export général. */
export function stripHealthForPublic(record) {
  if (!record) return record;
  const { health, ...rest } = record;
  return { ...rest, health: null, healthPresent: Boolean(health) };
}
